import { render, staticRenderFns } from "./DCheckbox.vue?vue&type=template&id=4cbbf86a&"
import script from "./DCheckbox.vue?vue&type=script&lang=js&"
export * from "./DCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports